import './AccessPage.css';

function AccessPage() {
  return (
    <div className="AccessPage">
      <div className="access-hero">
        <span className="access-hero-title">アクセス情報</span>
      </div>

      <div className="access-container">
        <div className="access-info">
          <p className="access-title">株式会社 高橋機工</p>
          <p className="access-text">
            〒985-0001 宮城県塩竈市新浜町1丁目26-15
          </p>
          <p className="access-text">JR仙石線 東塩釜駅 徒歩18分</p>
          <div className="access-details">
            <div className="access-detail">
              <span className="access-label">駐車場</span>
              <span className="access-value">10台</span>
            </div>
            <div className="access-detail">
              <span className="access-label">お車での目安</span>
              <span className="access-value">利府中IC から約15分</span>
            </div>
            <div className="access-detail">
              <span className="access-label">お問い合わせ</span>
              <span className="access-value">TEL：022-367-8361</span>
              <span className="access-value">MAIL：takahashikiko@aurora.ocn.ne.jp</span>
            </div>
            <div className="access-detail">
              <span className="access-label">入口案内</span>
              <span className="access-value">正面玄関よりお入りください</span>
            </div>
          </div>
        </div>

        <div className="access-map">
          <iframe
            title="株式会社高橋機工 アクセスマップ"
            src="https://www.openstreetmap.org/export/embed.html?bbox=141.0370%2C38.3250%2C141.0446%2C38.3307&layer=mapnik&marker=38.3278505%2C141.0408021"
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
            sandbox="allow-scripts allow-same-origin allow-popups"
          />
        </div>
      </div>
    </div>
  );
}

export default AccessPage;
